import React from 'react'
import { useOverlayA11y } from '../hooks/useOverlayA11y'
import { ProviderCredentialingPanel } from './ProviderCredentialingPanel'
import type { Provider } from '../lib/types'

export function ProviderDetailDrawer({ provider, onClose, onUpdated }: {
  provider: Provider
  onClose: () => void
  onUpdated: () => void
}) {
  const drawerRef = useOverlayA11y(onClose)

  return (
    <div className="drawer-bg" onClick={(e) => { if (e.target === e.currentTarget) onClose() }}>
      <div className="drawer" ref={drawerRef} role="dialog" aria-modal="true" aria-label={`Provider details for ${provider.name}`} tabIndex={-1}>
        <button className="drawer-close" onClick={onClose}>close ×</button>
        <h2>{provider.name}</h2>
        {provider.credentials && <div className="muted" style={{ marginBottom: 10 }}>{provider.credentials}</div>}
        <ProviderCredentialingPanel provider={provider} editable onUpdated={onUpdated} />
      </div>
    </div>
  )
}
